import { FieldMappingFieldItem } from '@components/text-editors/addons/field-mapping';

const VARIABLE_PATTERN = /{{\s*([^}]+?)\s*}}/g;

/**
 * Converts a mapping label template from the API (e.g. "{{name}} - {{details[category]}}")
 * into a FieldMappingTextEditor-compatible default value with _string suffixed variable keys.
 *
 * Returns { value, variables } where:
 * - value: template with _string suffixed keys, e.g. "{{name_string}} - {{details[category]_string}}"
 * - variables: map from suffixed key to the matching field item
 */
export const buildMappingLabelDefaultValue = (
  mappingLabel: string,
  fields: FieldMappingFieldItem[]
): { value: string; variables: Record<string, FieldMappingFieldItem> } => {
  const value = mappingLabel.replace(VARIABLE_PATTERN, (_, key) => `{{${key}_string}}`);
  const variables = Array.from(mappingLabel.matchAll(VARIABLE_PATTERN)).reduce((acc, [, key]) => {
    const field = fields.find((f) => f.label === key);
    if (field) {
      acc[`${key}_string`] = field;
    }
    return acc;
  }, {} as Record<string, FieldMappingFieldItem>);

  return { value, variables };
};
